module.exports = __webpack_public_path__ + "static/img/6-2.4582178.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/6-2.png
// module id = r2ke
// module chunks = 1